import React from "react";

const LoadingCard = () => (
  <div className="movie-card loading">
    <div className="loading-poster"></div>
    <div className="loading-title"></div>
  </div>
);

export default LoadingCard;
